import { render, staticRenderFns } from "./InfoView.vue?vue&type=template&id=33093e5d&scoped=true&"
import script from "./InfoView.vue?vue&type=script&lang=js&"
export * from "./InfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33093e5d",
  null
  
)

export default component.exports